import React from 'react';

import { TheoryPreviewBlock } from 'components/TheoryPreviewBlock';

import { Action } from '../Action';

import styles from './WebPreviewPage.module.scss';

const WebPreviewPage = ({
  nextLoading,
  isLastLessonInCourse,
  lesson,
  onNextLessonClick,
  isTestMode,
}: {
  nextLoading: any;
  isLastLessonInCourse: any;
  lesson: any;
  onNextLessonClick: any;
  isTestMode: any;
}) => (
  <div className={styles.page}>
    <div className={styles.inner}>
      <div className={styles.blocks}>
        {lesson.blocks.map((block: any) => (
          <TheoryPreviewBlock
            type={block.type}
            data={block.data}
            className={styles.theoryBlock}
          />
        ))}
      </div>
      <div className={styles.actions}>
        {isTestMode && (
          <Action
            nextLoading={nextLoading}
            isLastLessonInCourse={isLastLessonInCourse}
            onClick={onNextLessonClick}
          />
        )}
      </div>
    </div>
  </div>
);

export default React.memo(WebPreviewPage) as any;
